import ConnectedFileDialog from './ConnectedFileDialog'
import { FileDialog } from './FileDialog'
export { FileDialog }
export default ConnectedFileDialog
